import classNames from 'classnames';
import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import { BlockContent } from 'components/blocks/BlockContent';
import { NextLink } from 'components/blocks/NextLink';

import { ReactComponent as SvgMarker } from 'public/assets/icons/marker.svg';
import { useContactInformation } from 'util/useContactInformation';
import styles from './styles.module.scss';
import summerStyles from './summer-styles.module.scss';

export const ContactInformation = ({
  title,
  uuid,
  isOnSummerOverview,
}: {
  title: string,
  uuid: string,
  isOnSummerOverview?: boolean
}) => {
  const contactInfo = useContactInformation(uuid);

  const isLongTitle = title.length > 24;

  const contactsStyles = isOnSummerOverview ? summerStyles : styles;

  if (!contactInfo) return null;

  const { address: { city, country, postOffice }, email, phoneNumber } = contactInfo;

  return (
    <div className={contactsStyles.wrapBox}>
      <BoxWithShadow className={isOnSummerOverview ? contactsStyles.bg_green : contactsStyles.bg_blue}>
        <BlockContent className={contactsStyles.box}>
          <div className={contactsStyles.innerLeft}>
            <div>
              <span className={classNames('h2', contactsStyles.title, isLongTitle && contactsStyles.longTitle)}>{title}</span>
              <div className={contactsStyles.address}>
                <SvgMarker height={24} width={18} />
                <div>
                  <p>{postOffice}</p>
                  <p>
                    {city}
                    {' '}
                    {country}
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div className={contactsStyles.phone}>
                <p>
                  <NextLink href={`tel:${phoneNumber}`}>
                    {phoneNumber}
                  </NextLink>
                </p>
              </div>
              <div className={contactsStyles.email}>
                <p>
                  <NextLink href={`mailto:${email}`}>
                    {email}
                  </NextLink>
                </p>
              </div>
            </div>
          </div>
        </BlockContent>
      </BoxWithShadow>
    </div>
  );
};
